import Vue from 'vue';
// eslint-disable-next-line
export const storeFilterEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/customized-components/storeFilterEventBus.js